export default {
  props: {
    value: Array,
    clearable: Boolean,
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      pickDate: {},
      // 选中时间
      pickerOptions: {
        onPick: this.getPickDate,
        disabledDate: this.disabledDate
      }
    };
  },
  methods: {
    handleInput: function handleInput(val) {
      this.$emit("input", val);
    },
    getPickDate: function getPickDate(pick) {
      this.pickDate = pick;
    },
    disabledDate: function disabledDate(time) {
      if (this.disabled == true) {
        var _time = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1);
        return time.getTime() > _time.getTime();
      } else {
        return "";
      }
    }
  }
};